import React, {Component} from 'react';
import "react-csv-importer/dist/index.css";

import TableContent from "@components/Table/TableContent";
import {connect} from "react-redux";
import PageHeader from "@components/Table/PageHeader";
import { hasActiveFilters } from "@components/Table/filterState";

class EditableTable extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            searchString: null,
            filter_dates: [],
            triggered: false,
            isImportModalClosed: true,
            scroll: null,
            filterValues: null
        }
        this.calcScrollonResizeBind = this.calcScrollonResize.bind(this);
    }

    getTableHight() {
      try {
        const wrapHeight = document.body.clientHeight;
        const menuHeight = 70;
        const searchBarHeight = 70;
        const collapseHeight = document.getElementsByClassName('facility-calc-table-resize-collapse')[0]?.clientHeight;

        const diff = 120
        const tableHeight = wrapHeight - menuHeight - diff - (collapseHeight?collapseHeight+20:100);
        return Math.ceil(tableHeight)
      } catch (error) {
        console.error(error)

      }
    }

    calcScrollonResize() {
      const y = this.getTableHight()
      if(y && y !== this.state.scroll?.y) {
        this.setState({
          scroll: {
            x: 800,
            y
          }
        })
      }
    }

    componentDidMount() {
        this.calcScrollonResize();
        window.addEventListener('resize', this.calcScrollonResizeBind)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.calcScrollonResizeBind)
    }

    handleFresh = (e) => {
        this.tableRef.current.handleFresh()
    }

    createRecords = (e) => {
        return this.props.createRecords(e);
    }

    deleteRecord = (body) => {
        return this.props.deleteRecord(body)
    }

    bulkInsert = (rows) => {
        return this.props.bulkInsert(rows)
    }

    bulkDelete = (body) => {
        return this.props.bulkDelete(body)
    }

    editRecords = (key, row) => {
        this.props.editRecords(key, row)
    }

    handOnlineSave = (key, row) => {
        return this.props.handOnlineSave(key, row)
    }

    handleFilter = (query) => {
        return this.props.handleFilter(query)
    }

    handleSelect = (e) => {
        e = e ? e : null
        this.setState({
            searchString: e
        })
    }

    getRecord = (data) => {
        this.props.getRecord(data)
    }

    setFilterDates = (dates) => {
        this.setState({
            filter_dates: dates,
            triggered: !this.state.triggered
        }, function () {
            this.props.setFilterDates(dates)
        })

    }

    setFilters = (e) => {
        this.setState({
            filterValues: e
        });
        this.props.setFilters(e)
    }

    resetFilters = () => {
        this.setState({
            filterValues: null,
            searchString: null
        });
        if (typeof this.props.resetFilters === "function") {
            return this.props.resetFilters();
        }
    }

    refresh = (needRequest = true) => {
        this.tableRef.current.refresh(needRequest);
    };

    getFormRef = (formRef) => {

        if (this.props.getFormRef) {
            this.props.getFormRef(formRef);
        }
    }

    handleRegister = (e, data) => {
        this.props.handleRegister(e, data)
    }

    handleCloseImportModalRequest = (e) => {
        console.log('CloseImportModalRequest', e)
        this.setState({
            isImportModalClosed: e
        })
    }



    render() {
        const showRelatedFilterToolbar =
            this.props.relatedList &&
            typeof this.props.renderSearches === "function";
        const showPageHeader =
            !this.props.relatedList || showRelatedFilterToolbar;

        return (
            <div className={this.props.isRelated ? '' : ''}>




                <section className="bg-white cardWrapper outerCardWrapper">

                    <TableContent
                        getActionRef={this.props.getActionRef}
                        ref={this.tableRef}
                        data={this.props.data}
                        formClassName={this.props.formClassName}
                        columnProps={this.props.columnProps}
                        columns={this.props.columns}
                        postComment={this.props.postComment}
                        formFields={this.props.formFields}
                        getRecord={this.getRecord}
                        createRecords={this.createRecords}
                        deleteRecord={this.deleteRecord}
                        bulkInsert={this.bulkInsert}
                        canDelete={this.props.canDelete}
                        bulkDelete={this.bulkDelete}
                        handOnlineSave={this.handOnlineSave}
                        handleFresh={this.handleFresh}
                        handleFilter={this.handleFilter}
                        searchString={this.state.searchString}
                        handleGlobalSearch={this.handleSelect}
                        formRelated={this.props.formRelated}
                        relatedList={this.props.relatedList}
                        filter_dates={this.props.filter_dates}
                        triggered={this.state.triggered}
                        isRowClickable={this.props.isRowClickable}
                        isRowSelectable={this.props.isRowSelectable}
                        selected_row={this.props.selected_row}
                        textAlign={this.props.textAlign}
                        userPermission={this.props.userPermission}
                        setSelectedRows={this.props.setSelectedRows}
                        relatedObject={this.props.relatedObject}
                        relatedId={this.props.relatedId}
                        isChat={this.props.isChat}
                        isRelated={this.props.isRelated}
                        isAttachments={this.props.isAttachments}
                        isMetrics={this.props.isMetrics}
                        hide_search={this.props.hide_search}
                        isRowSelection={this.props.isRowSelection}
                        isResetPassword={this.props.isResetPassword}
                        handleRegister={this.handleRegister}
                        expandedRowRender={this.props.expandedRowRender}
                        getFormRef={this.getFormRef}
                        readonly={this.props.readonly}
                        customButton={this.props.customButton}
                        isImportModalClosed={this.state.isImportModalClosed}
                        onCloseImportModalRequest={this.handleCloseImportModalRequest}
                        isRowHover = {this.props.isRowHover}
                        isAdditionalForm={this.props.isAdditionalForm}
                        renderAdditionalForm={this.props.renderAdditionalForm}
                        scroll={this.state.scroll}
                        onDoubleClick={this.props.onDoubleClick}
                        mobileInfiniteScroll={this.props.mobileInfiniteScroll}
                        mobilePageSize={this.props.mobilePageSize}
                        mobileRowActions={this.props.mobileRowActions}
                        hideMobileColumnActions={this.props.hideMobileColumnActions}
                        hideMobileTableExpand={this.props.hideMobileTableExpand}
                        mobileCardHeaderRender={this.props.mobileCardHeaderRender}
                        mobileExpandedExcludeKeys={this.props.mobileExpandedExcludeKeys}
                        mobileExpandedIncludeKeys={this.props.mobileExpandedIncludeKeys}
                        editable={this.props.editable}
                        pageHeader={showPageHeader ? (
                            <PageHeader
                            data={this.props.data}
                            renderButtons={this.props.renderButtons}
                            formFields={this.props.formFields}
                            createRecords={this.createRecords}
                            columnProps={this.props.columnProps}
                            handleFresh={this.handleFresh}
                            handleSelect={this.handleSelect}
                            filter_dates={this.state.filter_dates}
                            setFilterDates={this.setFilterDates}
                            hide_date={this.props.hide_date}
                            hide_search={this.props.hide_search}
                            hide_imports={
                                this.props.hide_imports || showRelatedFilterToolbar
                            }
                            setFilters={this.setFilters}
                            renderFilter={this.props.renderFilter}
                            resetFilters={this.props.resetFilters ? this.resetFilters : undefined}
                            filterHasValue={
                                this.props.filterHasValue ||
                                hasActiveFilters(
                                    this.props.filterValues,
                                    this.state.filterValues,
                                    this.state.filter_dates,
                                    this.state.searchString
                                )
                            }
                            filterValues={this.state.filterValues}
                            userPermission={this.props.userPermission}
                            isHideRefreshNews={this.props.isHideRefreshNews}
                            hid_new={this.props.hid_new}
                            new_text={this.props.new_text}
                            onNew={this.props.onNew}
                            filterDescription={this.props.filterDescription}
                            renderSearches={this.props.renderSearches}
                            formClassName={this.props.formClassName}
                            getFormRef={this.getFormRef}
                            onCloseImportModalRequest={this.handleCloseImportModalRequest}
                        />
                        ) : ""}
                        defaultDisplayColumns={this.props.defaultDisplayColumns}
                        tableClassName={this.props.tableClassName}
                        tableExpandable={this.props.tableExpandable}
                        selectionColumnWidth={this.props.selectionColumnWidth}
                        wrapperRowClassName={this.props.wrapperRowClassName}
                    />

                </section>
            </div>
        );
    }

}


const mapStateToProps = state => {
    return {
        loading: state.EditableTable.load
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(EditableTable);


